import React from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as S from './styles';

export interface Kpi {
  rotulo: string;
  /** Numero e formatado em pt-BR; texto sai como veio (ex.: "R$ 1.500,00"). */
  valor: number | string;
  icone?: IconDefinition;
}

interface KpiCardsProps {
  itens: Kpi[];
}

const formata = (valor: number | string) =>
  typeof valor === 'number' ? valor.toLocaleString('pt-BR') : valor;

/** Cartoes de indicadores do topo do resultado (contagens, totais). */
const KpiCards: React.FC<KpiCardsProps> = ({ itens }) => (
  <S.Lista>
    {itens.map((item) => (
      // o aria-label deixa o card localizavel pelo proprio rotulo, em vez de
      // "item 1 de 3"
      <S.Card key={item.rotulo} aria-label={item.rotulo}>
        {item.icone && (
          <S.Icone>
            <FontAwesomeIcon icon={item.icone} />
          </S.Icone>
        )}
        <S.Texto>
          <S.Valor>{formata(item.valor)}</S.Valor>
          <S.Rotulo>{item.rotulo}</S.Rotulo>
        </S.Texto>
      </S.Card>
    ))}
  </S.Lista>
);

export default KpiCards;
